<template>

    <div class="form-candidate FormCandidate.vue full-container block">
      <!--<main-menu class="center-logo"></main-menu>-->
      <div class="form__content">
        <a href="javascript:void(0);" class="go-back" @click="goBack">
          <arrowBack id="arrow-back"></arrowBack>
        </a>

        <h1 class="title-primary animated fadeInUp delay1000ms">Pra finalizar, preenche teus dados.</h1>

        <form @submit="goToThanksPage" class="animated fadeInUp delay1500ms">
          <div class="form-group fake-label" v-if="!guestName">
            <input v-fakelabel @keyup="chekEmptyField" v-model="form.name" type="text" class="bold-control" placeholder="Nome" maxlength="50" required>
            <label>Nome</label>
          </div>
          <div class="form-group fake-label">
            <input v-fakelabel @keyup="chekEmptyField" v-model="form.email" type="email" class="bold-control" placeholder="E-mail" maxlength="50" required>
            <label>E-mail</label>
          </div>
          <div class="form-group fake-label">
            <input v-fakelabel pattern="[0-9]{2} [0-9]{4}.[0-9]{4}([0-9])?" @keyup="chekEmptyField" @blur="chekEmptyField" type="text" class="bold-control phone" placeholder="00 0000.00000" maxlength="13" required>
            <label>Telefone</label>
          </div>
          <div class="form-group fake-label">
            <input v-fakelabel @keyup="chekEmptyField" v-model="form.linkedin" type="text" class="bold-control" placeholder="LinkedIn" minlength="5" maxlength="200" required>
            <label>Linkedin</label>
          </div>
          <div class="form-group fake-label">
            <input v-fakelabel @keyup="chekEmptyField" v-model="form.facebook" type="text" class="bold-control" placeholder="Facebook" minlength="5" maxlength="200">
            <label>Facebook</label>
          </div>
          <div class="form-group fake-label">
            <input v-fakelabel @keyup="chekEmptyField" v-model="form.portfolio" type="text" class="bold-control" placeholder="Portfólio" maxlength="200">
            <label>Portfólio</label>
          </div>
          <div class="form-group fake-label textarea">
            <textarea v-fakelabel @keyup="chekEmptyField" v-model="form.message" @keydown="resizeTextarea" class="bold-control" placeholder="Quer falar algo mais? Somos todos ouvidos..." minlength="10" maxlength="1024"></textarea>
            <label>Mensagem</label>
          </div>

          <button type="submit" class="btn btn-bold btn-lg btn-padding-lg">enviar</button>
        </form>

      </div>
    </div>
</template>

<script>
//  import MainMenu from './MainMenu.vue'
  import arrowBack from './arrowBack.vue'
  import mask from 'jquery-mask-plugin';

  export default {
    name: 'FormCandidate',
    data() {
      return {
        form: {
          name: '',
          email: '',
          phone: '',
          linkedin:'',
          facebook:'',
          portfolio:'',
          message:''
        }
      }
    },
    computed: {
        guestName() {
            return this.$store.getters.guestFirstName;
        },
    },
    components: {
//      MainMenu,
      arrowBack
    },
    mounted(){
      this.log('mounted: ' + this.$options.name);
      // seta a classe do menu principal
      this.$store.commit('setMenuClass', '');

      let $this = this;
      $('.phone').mask('00 0000.00009', {
        onChange(val){
          $this.form.phone = val;
        },
        placeholder: 'Telefone'
      });
    },
    beforeDestroy(){
      $('.phone').unmask();
    },
    methods:{
      goBack(){
        this.$router.go(-1);
      },
      goToThanksPage(event){
        let $this = this;
        event.preventDefault();
        window.scroll(0,0);
        if (!this.guestName){
            this.$store.commit('setGuestName', this.form.name);
        }

        let postData = [
          {name: 'identificador', value: 'contato_candidato'},
          {name: 'tok'+'en_rds'+'tation', value: '76d813f385092cd1'+'c7a5e954a4c73c5e'},
          {name: 'nome', value: this.$store.state.guestName},
          {name: 'tipo', value: this.$store.state.candidate.type},
          {name: 'vaga', value: this.$store.state.candidate.position},
          {name: 'email', value: this.form.email},
          {name: 'telefone', value: this.form.phone},
          {name: 'linkedin', value: this.form.linkedin},
          {name: 'facebook', value: this.form.facebook},
          {name: 'portfolio', value: this.form.portfolio},
          {name: 'mensagem', value: this.form.message}
        ];

        $('.loading').removeClass('hideL');

        RdIntegration.post(postData, function () {
          $this.$router.push('/thanks');
        });

        return false;
      },
      resizeTextarea(event){
        let el = event.target;
        setTimeout(function(){
          el.style.cssText = 'height:auto;';
          el.style.cssText = 'height:' + (el.scrollHeight+2) + 'px';
        },0);
      },
      chekEmptyField(event){
        let el = $(event.target);
        if (el.val().length > 0){
          el.parent().addClass('white');
        }else{
          el.parent().removeClass('white');
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/FormCandidate.vue